import Button from "./button";
import Save from "./save";

export default function ButtonSave(props) {
    const { children } = props;

    return <Button { ...props } className="button--green" leftIcon={<Save/>}>{ children ? children : 'Save' }</Button>
}